<template>
    <modal name="contact-us-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
        overlayTransition="overlay"
        @before-close="beforeClose"
    >
        <div class="rounded-lg bg-white px-12 py-12">
            <h2 class="text-center text-2xl text-green-warm-600 pb-8">
                Contact Us
            </h2>

            <div class="text-center flex flex-col">
                <div class="border-b border-gray-300 pb-4 mb-4">
                    <p class="mb-0 text-lg text-blue-600">If you need immediate assistance:</p>
                    <p class="mb-0 text-sm">Contact us at (520) 771-2455</p>
                    <p class="mb-0 text-sm"></p>
                </div>

                <div class="border-b border-gray-300 pb-4 mb-4">
                    <p class="mb-0 text-lg text-blue-600">Otherwise:</p>
                    <p class="mb-0 text-sm">Email us at <a href="mailto:support@contract2close.com" class="text-blue-600 underline hover:text-blue-400 outline-none">support@Contract2Close.com</a></p>
                    <p class="mb-0 text-sm">and allow up to 24 hours for a response from our support team.</p>
                </div>

                <div>
                    <p class="mb-0 text-sm">Contract2Close.com</p>
                    <p class="mb-0 text-sm">14541 North Rocky Highlands Drive</p>
                    <p class="mb-0 text-sm">Oro Valley, Arizona 85755</p>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: {
        show: {},
    },

    methods: {
        beforeClose(event) {
            this.$emit('closed');
        },
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show('contact-us-modal');
            } else {
                this.$modal.hide('contact-us-modal');
            }
        },
    },

}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
